var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "swiper",
    {
      ref: "swiper",
      staticClass: "swiper",
      attrs: { options: _vm.swiperOptions },
    },
    [
      _vm._l(_vm.items, function (item, index) {
        return _c("swiper-slide", { key: index }, [
          _c("div", { staticClass: "text-center space-y-3 pb-18" }, [
            _c("img", {
              staticClass: "w-13 block mx-auto",
              attrs: { src: item.icon[0].url, alt: item.icon[0].title },
            }),
            _vm._v(" "),
            _c("h4", {
              staticClass: "text-sm leading-snug text-black text-opacity-70",
              domProps: { innerHTML: _vm._s(_vm.nl2br(item.text)) },
            }),
          ]),
        ])
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "swiper-pagination",
        attrs: { slot: "pagination" },
        slot: "pagination",
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }